module.exports = __webpack_public_path__ + "img/bb_g1_t_eyes-05.2edc811c.svg";